import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { User } from 'firebase/auth';
import { AuthProvider } from './contexts/AuthContext';
import { WildsearchProvider } from './contexts/WildsearchContext';
import { App } from './App';

/**
 * Main application (post-authentication)
 * Has its own Router, independent of auth flow
 * Receives authenticated user from AppRoot
 */
export const MainApp: React.FC<{ user: User }> = ({ user }) => {
  console.log('MainApp loaded for user:', user.email);
  
  return (
    <BrowserRouter>
      <AuthProvider user={user}>
        <WildsearchProvider>
          <App />
        </WildsearchProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};
